import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { apiService } from '../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';

function KnowledgeCategory({ onCategorySelect ,onSubCategorySelect,onKbaseSelect,
    selectedKbaseId, 
    selectedCategory, 
    selectedSubCategory 
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const [catsloading, setCatsLoading] = useState(false);
    const [catsList, SetlistingCats] = useState([]);
    const [catidsclass, setCatidsclass] = useState(selectedCategory);
    const [catidsbaseclass, setCatidsBaseclass] = useState(selectedCategory);
    const [catidssubclass, setCatidsSubclass] = useState(selectedSubCategory);
    
    useEffect(() => {
        const fetchData = async () => {
            setCatsLoading(true);
            try {
            const response = await apiService.getRequest('knowledge-bases-with-categories-and-subcategories');
            if (response && response.success === true) {
                SetlistingCats(response.data); 
            }else{
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            }catch (error) {
                console.error('Error fetching tab data:', error);
            } finally {
                setCatsLoading(false);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        setCatidsBaseclass(selectedKbaseId);
        setCatidsclass(selectedSubCategory);
        setCatidsSubclass(selectedCategory);
    }, [selectedKbaseId, selectedCategory, selectedSubCategory]);
    const handleKbaseClick = (kBaseId) => {
        onKbaseSelect(kBaseId, "");
        setCatidsBaseclass(kBaseId);   
        setCatidsclass("");
        setCatidsSubclass("");
    };
    const handleCategoryClick = (categoryId) => {
        onCategorySelect(categoryId, ""); 
        setCatidsSubclass(categoryId);
        setCatidsclass("");
    };

    const handleSubCategoryClick = (subCategoryId) => {
        onSubCategorySelect(subCategoryId,"");
        setCatidsclass(subCategoryId);
    };
  return (
    <div className='klgcategory_main dragging_cats'>
        <div className='d-flex flex-column'>
            <Accordion>
            {catsloading ? 
            <div className='d-flex justify-content-center w-100'>
                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :<>
            {catsList && catsList.length > 0 ? (
                catsList && catsList.map((catsListings,index) => (
                <Accordion.Item eventKey={index} key={catsListings.id}>
                    <Accordion.Header onClick={()=> currentPath === "/knowledge"
                    ? handleKbaseClick(catsListings.id)
                    : (navigate('/knowledge'), localStorage.setItem('knowledgeKbaseBackId', String(catsListings.id)))} className={catidsbaseclass && catidsbaseclass === catsListings.id ? 'clicked_boldarticle' : ''}><div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsListings.name}</div>
                    <span style={{fontWeight:"600"}} className='article_countshow'>{catsListings.articles_count || "0"}</span>
                    </Accordion.Header>
                    <Accordion.Body> 
                        <Accordion defaultActiveKey="0">
                        {catsListings && catsListings.categories && catsListings.categories.length > 0 ? (
                            catsListings.categories && catsListings.categories.map((catsmainListings,index) => (
                            <Accordion.Item eventKey={index} key={catsmainListings.id}>
                                <Accordion.Header onClick={()=> currentPath === "/knowledge"  
                                    ? handleCategoryClick(catsmainListings.id)
                                    : (navigate('/knowledge'), localStorage.setItem('knowledgeCatBackId', String(catsmainListings.id)))} className={catidssubclass && catidssubclass === catsmainListings.id ? 'clicked_boldarticle' : ''}><div className='div_kbacategory_listwidth'><img src={require('../../assets/chevron-down.svg').default} alt=''/>{catsmainListings.name}</div>
                                    <span className='article_countshow'>{catsmainListings.articles_count || "0"}</span>
                                    </Accordion.Header>
                                <Accordion.Body className='ps-0'>  
                                <div className='d-flex flex-column'>
                                    {catsmainListings && catsmainListings.subcategories && catsmainListings.subcategories.length > 0 ? (
                                        catsmainListings.subcategories && catsmainListings.subcategories.map((sublistings) => (
                                        <span 
                                            key={sublistings.id} 
                                            onClick={() => 
                                                currentPath === "/knowledge"
                                                    ? handleSubCategoryClick(sublistings.id)
                                                    : (navigate('/knowledge'), localStorage.setItem('knowledgeBackId', String(sublistings.id)))
                                            }
                                            className={catidsclass && catidsclass === sublistings.id ? 'clicked_boldarticle d-flex align-items-center' : 'd-flex align-items-center'}
                                        >
                                            <div className='div_kbacategory_listwidth'>{sublistings.name}</div>
                                            <span className='article_countshow'>{sublistings.articles_count || "0"}</span>
                                        </span>))
                                        ) : (
                                            <div className="w-100 d-flex justify-content-center">
                                                <p>No data to display</p>
                                            </div>
                                        )}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            ))
                        ) : (
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                        </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
                ))
                ) : (
                    <div className="w-100 d-flex justify-content-center mt-4">
                        <p>No data to display</p>
                    </div>
                )}
                </>}
                </Accordion>
        </div>
    </div>
  )
}

export default KnowledgeCategory
